import { FiltersToolbar } from "@components/commerce/product-listing/filters/toolbar/FiltersToolbar";
import type { IPartFilter, IPartStoryTile } from "@contentful-api/types/contentful";
import { Box } from "@ecco/ui/box";
import { sizes } from "@ecco/ui/tokens";
import type { FC } from "react";
import { ProductList } from "./product-tile-list/ProductList";
import { useFilterStore } from "@store/filterStore";
import { Flex } from "@ecco/ui/flex";
import SortBy from "@components/commerce/product-listing/filters/toolbar/item/sortBy/SortBy";
import { useLgBreakpoint } from "@ecco/ui/use-breakpoint";
import { useStore } from "@store/store";
import { useShowTargetGroupFilter } from "@lib/utils/plp/useShowTargetGroupFilter";
import { ProductCategoryFilter } from "./filters/product-category-filter/ProductCategoryFilter";

interface IProductListingProps {
    listOfFilters: IPartFilter[];
    locale: string;
    widgetSize?: string;
    editorialWidgets?: IPartStoryTile[];
}

export const ProductListing: FC<IProductListingProps> = ({
    listOfFilters,
    locale,
    widgetSize,
    editorialWidgets,
}) => {
    const filtersDialogOpened = useFilterStore((state) => state.filtersDialogOpened);
    const isDesktopView = useLgBreakpoint();
    const hasActiveTimer = useStore((state) => state.data.hasActiveTimer);
    const showTargetGroupFilter = useShowTargetGroupFilter(listOfFilters);

    return (
        <>
            {showTargetGroupFilter && <ProductCategoryFilter />}
            <Box data-testid="product-listing" position="relative">
                {/* SortBy - hidden on mobile, visible on desktop, non-sticky */}
                {isDesktopView && (
                    <Box
                        position="absolute"
                        top={0}
                        mt={hasActiveTimer ? 7 : 1}
                        right={0}
                        w="auto"
                        px={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}
                        zIndex={filtersDialogOpened ? 4 : 3}
                    >
                        <Flex justifyContent="flex-end" alignItems="center" height="60px">
                            <SortBy locale={locale} />
                        </Flex>
                    </Box>
                )}
                <Box
                    position="sticky"
                    w="100%"
                    top={[
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 35px)`,
                    ]}
                    zIndex={filtersDialogOpened ? 3 : 2}
                    boxSizing="border-box"
                    px={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}
                >
                    <FiltersToolbar listOfFilters={listOfFilters} locale={locale} />
                </Box>
                <Box position="relative">
                    <Box position="relative" display="block">
                        <ProductList widgetSize={widgetSize} editorialWidgets={editorialWidgets} />
                    </Box>
                </Box>
            </Box>
        </>
    );
};
